import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 300px;
  position: relative;
  height: auto;

  .average-score {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 16px;
    width: 100%;
    height: 120px;
    gap: 17px;
    background-color: ${(props) => props.theme.colors.main_cta};
    color: ${(props) => props.theme.colors.black};
    cursor: default;

    .score {
      font-size: 35px;
      font-weight: 700;
    }

    &.no-score {
      background-color: ${(props) => props.theme.colors.outline};
      color: ${(props) => props.theme.colors.inactive};
    }
  }

  .horizont-line {
    width: 100%;
    height: 0;
    border: 1px solid ${(props) => props.theme.colors.outline};
  }

  &:has(.report-btn) {
    &:hover .report-btn {
      opacity: 0.8;
    }
  }

  .report-btn {
    position: absolute;
    top: 12px;
    right: 16px;
    border: none;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s;
  }
`;

export default { Wrapper };
